module.exports = __webpack_public_path__ + "static/media/Desktop5.c1d64799.jpg";